export default{
    setBaseInfo(state, data) {        
        state.baseInfo = data;
    },
    setDrawTime(state, data) {        
        state.lotteryDrawTime = data;
    },
}